import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { JobCompleteCofirmationModalComponent } from "../../../job-complete-cofirmation-modal/job-complete-cofirmation-modal.component";
// import { JobCompleteCofirmationModalComponent } from "../../../job-complete-cofirmation-modal/job-complete-cofirmation-modal.component";

@Component({
    selector: 'notification-booking',
    templateUrl: './notification-booking.component.html',
    styleUrls: ['../notification.component.scss', './notification-booking.component.scss'],
})
export class NotificationBookingComponent implements OnInit {

    @Input() data: any;

    
    ngOnInit(): void {

    }
    constructor(private   modalService: NgbModal,){
        
    }

    openWhatsapp() {
        window.open(`https://wa.me/${this.data.payload?.phoneNumber}`, '_blank');
    }
    
    openWorkDoneConfirmation(){
        const modalRef= this.modalService.open(
            JobCompleteCofirmationModalComponent,{
                size: 'sm',
                windowClass: 'confirmation-modal'
            }
        );
        modalRef.componentInstance.jobId = this.data.payload.jobId;
        
    }
}